export default "__VITE_ASSET__FIyi5cD5__"